import Sidebar from './sidebar';
import { TemplateProps } from '../index';
import './styles_old.scss';
import './styles.scss';
import Page from '../../page';
import Home from './home';
import Search from './search';
import CategoryInner from './category-inner';
import CategoryOuter from './category-outer';
import CatalogWrapper from './catalog-wrapper';
import NotFound from './not-found';
import Product from './product';

function Oni({ hasPendingRequests }: TemplateProps) {
    return (
        <div className="row oni-catalog">
            <div className="preloader" style={{ display: hasPendingRequests ? 'block' : 'none' }}>
                <span className="spinner" />
            </div>
            <Sidebar />
            <Page
                home={Home}
                search={Search}
                categoryOuter={CategoryOuter}
                categoryInner={CategoryInner}
                catalog={CatalogWrapper}
                product={Product}
                notFound={NotFound}
            />
        </div>
    );
}

export default Oni;
